module.exports = __webpack_public_path__ + "media/images/front/company/company_1-f8226a474a5340eea502c4a4533cdba5.jpg";